import LegalPage from '@/components/marketing/LegalPage';

export default function TermsPage() {
  return (
    <LegalPage title="Terms of Service" lastUpdated="February 2026" testId="terms-page">
      <p className="text-base text-slate-200">
        These Terms of Service ("<strong>Terms</strong>") form a binding agreement between you and
        PROP VEIW ("<strong>we</strong>", "<strong>us</strong>", "<strong>our</strong>") and govern
        your access to and use of the PROP VEIW website, applications, and services (collectively,
        the "<strong>Service</strong>"). By creating an account or using the Service you agree to
        these Terms. If you do not agree, do not use the Service.
      </p>

      <h2>1. Eligibility &amp; Accounts</h2>
      <p>
        You must be at least 18 years old and able to form a binding contract to use the Service.
        You are responsible for maintaining the confidentiality of your account credentials and for
        all activity that occurs under your account. Notify us immediately at{' '}
        <a href="mailto:security@propveiw.com">security@propveiw.com</a> of any unauthorized use.
      </p>

      <h2>2. Subscription Plans, Trial, and Billing</h2>
      <p>
        The Service is offered on subscription tiers (Starter, Pro, and Business). New customers
        may start a 14-day free trial; a valid payment method is required to begin the trial. If
        you do not cancel before the trial ends, you authorize us to charge your payment method
        the then-current subscription fee.
      </p>
      <ul>
        <li>Subscriptions renew automatically each billing period until cancelled.</li>
        <li>Fees are non-refundable except where required by law.</li>
        <li>You may cancel at any time from the account settings; cancellation takes effect at the end of the current billing period.</li>
        <li>We may modify pricing with at least thirty (30) days' prior notice.</li>
      </ul>

      <h2>3. Customer Data &amp; Multi-Tenancy</h2>
      <p>
        You retain all rights to the data you submit to the Service ("<strong>Customer Data</strong>").
        We process Customer Data only as needed to operate the Service for you and in accordance
        with our <a href="/privacy">Privacy Policy</a>. Each organization's data is logically
        isolated from every other organization's data through scoped access controls.
      </p>

      <h2>4. Acceptable Use</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Reverse engineer, decompile, or attempt to extract source code from the Service.</li>
        <li>Use the Service to send unsolicited marketing, run brute-force attacks, or scrape data.</li>
        <li>Upload illegal, infringing, or harmful content, including content that violates the privacy of your guests.</li>
        <li>Resell, sublicense, or white-label the Service without a written agreement.</li>
      </ul>

      <h2>5. Staff Seats &amp; Invited Users</h2>
      <p>
        When you invite staff (cleaners, maintenance, landscapers, etc.) to your organization,
        they may access only the records and roles you grant them. You are responsible for
        the actions of users you invite and for promptly removing access when those users leave
        your team.
      </p>

      <h2>6. Third-Party Integrations</h2>
      <p>
        The Service connects to optional third-party platforms (e.g., Airbnb, VRBO, Booking.com,
        Resend, Google). Your use of those platforms is governed by their own terms. We are not
        responsible for outages or content provided by third parties.
      </p>

      <h2>7. Intellectual Property</h2>
      <p>
        The Service, including all software, designs, trademarks, and documentation, is owned by
        PROP VEIW and licensed (not sold) to you on a non-exclusive, non-transferable, revocable
        basis solely for your internal business use during the subscription period.
      </p>

      <h2>8. Disclaimers</h2>
      <p>
        THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EXPRESS
        OR IMPLIED, INCLUDING MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND
        NON-INFRINGEMENT. We do not guarantee that the Service will be uninterrupted,
        error-free, or completely secure.
      </p>

      <h2>9. Limitation of Liability</h2>
      <p>
        TO THE MAXIMUM EXTENT PERMITTED BY LAW, IN NO EVENT WILL PROP VEIW BE LIABLE FOR ANY
        INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR FOR LOST PROFITS OR
        REVENUES. OUR TOTAL LIABILITY FOR ANY CLAIM RELATED TO THE SERVICE WILL NOT EXCEED THE
        FEES YOU PAID US IN THE TWELVE (12) MONTHS PRECEDING THE CLAIM.
      </p>

      <h2>10. Indemnification</h2>
      <p>
        You agree to defend, indemnify, and hold harmless PROP VEIW and its affiliates from any
        claim arising out of (a) your misuse of the Service, (b) your Customer Data, or (c) your
        violation of these Terms.
      </p>

      <h2>11. Termination</h2>
      <p>
        We may suspend or terminate your access to the Service if you materially breach these
        Terms or if your account is used in a way that endangers the platform or other users.
        Upon termination, we will give you thirty (30) days to export your Customer Data, after
        which we may delete it.
      </p>

      <h2>12. Governing Law</h2>
      <p>
        These Terms are governed by the laws of the State of Delaware, United States, without
        regard to its conflict-of-law provisions. Disputes will be resolved exclusively in the
        state or federal courts located in Wilmington, Delaware.
      </p>

      <h2>13. Changes to the Terms</h2>
      <p>
        We may update these Terms from time to time. Material changes will be announced via email
        or in-app notice at least fourteen (14) days before they take effect. Continued use of
        the Service after the effective date constitutes acceptance of the updated Terms.
      </p>

      <h2>14. Contact</h2>
      <p>
        Questions about these Terms? Email{' '}
        <a href="mailto:legal@propveiw.com">legal@propveiw.com</a>.
      </p>
    </LegalPage>
  );
}
